var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"duel-challenge-title",class:_vm.$mq},[_vm._v(" "+_vm._s(_vm.isChallenger ? _vm.$t("duels.challenge-issued") : _vm.$t("duels.challenge"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }